import { http } from './index'
import axios from 'axios'
/**
 * This cancel token lets you cancel request on demand
 * @type {CancelTokenStatic|*}
 */
const CancelToken = axios.CancelToken
let cancelations = []

const street = '/streets'

class Streets {
  static getStreets = async (payload) => {
    try {
      const res = await http.get(
        street,
        {
          params: {
            queryText: payload
          }
        },
        {
          cancelToken: new CancelToken(function executor(c) {
            cancelations.push(c)
          })
        }
      )
      return res.data
    } catch (error) {
      console.error(error)
      return null
    }
  }
}

export default Streets
